module.exports = __webpack_public_path__ + "img/rotate-device.fb09133e.png";